import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <>
      <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s" style={{
        background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)'
      }}>
        <div className="container py-5">
          <div className="row g-5 mb-5 align-items-center">
            <div className="col-lg-7">
              <div className="mb-4">
                <h4 className="text-white mb-3">
                  <i className="fas fa-bell me-2"></i>
                  Stay Updated with WiZiAi
                </h4>
                <p className="text-light opacity-75 mb-3">
                  Get the latest updates on new features, study tips, and success stories directly in your inbox.
                </p>
              </div>
              <div className="position-relative mx-auto">
                <input 
                  className="form-control w-100 py-3 ps-4 pe-5 border-0" 
                  type="email"
                  placeholder="Enter your email for study updates and tips"
                  style={{ borderRadius: '50px' }}
                />
                <button 
                  type="button"
                  className="btn position-absolute top-0 end-0 py-2 px-4 mt-2 me-2"
                  style={{
                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                    border: 'none',
                    borderRadius: '50px',
                    color: 'white'
                  }}>
                  <i className="fas fa-paper-plane me-1"></i>
                  Subscribe
                </button>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="d-flex align-items-center justify-content-center justify-content-lg-end">
                <a className="btn btn-light btn-md-square me-3" href="https://facebook.com/wiziai" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a className="btn btn-light btn-md-square me-3" href="https://twitter.com/wiziai" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a className="btn btn-light btn-md-square me-3" href="https://instagram.com/_wiziai_" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a className="btn btn-light btn-md-square me-3" href="https://linkedin.com/wiziai" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a className="btn btn-light btn-md-square me-0" href="https://youtube.com/wiziai" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <div className="footer-item">
                  <div className="d-flex align-items-center mb-3">
                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle me-3"
                      style={{ 
                        width: '50px', 
                        height: '50px',
                        background: 'linear-gradient(135deg, #667eea, #764ba2)'
                      }}>
                      <img src="/logo.png" alt="WiZiAi Logo" style={{ border: '2px solid white', borderRadius: '10%', width: '50px', height: '50px' }} />
                    </div>
                    <h3 className="text-white fw-bold mb-0">WiZiAi</h3>
                  </div>
                  <p className="mb-3 text-light opacity-75">
                    Empowering JEE and NEET aspirants with AI-powered personalized learning, 
                    intelligent practice tests, and voice-enabled doubt solving for guaranteed success.
                  </p>
                  {/* <div className="row g-2">
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-users text-primary me-2"></i>
                        <div>
                          <small className="text-light opacity-75 d-block">Students</small>
                          <strong className="text-white">15,000+</strong>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-graduation-cap text-primary me-2"></i>
                        <div>
                          <small className="text-light opacity-75 d-block">Success Rate</small>
                          <strong className="text-white">98%</strong>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">
                  <i className="fas fa-link me-2"></i>
                  Quick Links
                </h4>
                <Link to="/" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-home me-2"></i>Home
                </Link>
                <Link to="/about" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-info-circle me-2"></i>About WiZiAi
                </Link>
                <Link to="/contact" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-envelope me-2"></i>Contact Us
                </Link>
                <Link to="/blog" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-blog me-2"></i>Blog
                </Link>
              </div>
            </div>
            <div className="col-md-5 col-lg-5 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">
                  <i className="fas fa-graduation-cap me-2"></i>
                  Our Services
                </h4>
                <Link to="/login" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-chart-bar me-2"></i>WiziBoard Dashboard
                </Link>
                <Link to="/login" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-microphone-alt me-2"></i>WiziTalk AI Tutor
                </Link>
                <Link to="/login" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-medal me-2"></i>WiziRank Leaderboard
                </Link>
                <Link to="/login" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-edit me-2"></i>AI Mock Tests
                </Link>
                <Link to="/login" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-question-circle me-2"></i>Instant Doubt Solver
                </Link>
              </div>
            </div>
            <div className="col-md-7 col-lg-7 col-xl-4">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">
                  <i className="fas fa-phone me-2"></i>
                  Contact Info
                </h4>
                <a href="https://maps.google.com/?q=Tech+Park,+Bangalore,+India" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   className="text-light opacity-75 text-decoration-none mb-3 hover-primary">
                  <i className="fa fa-map-marker-alt text-primary me-3"></i>
                  Lakshya Campus Building,<br />
                  2nd Floor, Opp Ana Sagar lake,<br />
                  Vaishali Nagar, Ajmer, Rajasthan (305001)
                </a>
                <a href="mailto:support@wiziai.com" className="text-light opacity-75 text-decoration-none mb-2 hover-primary">
                  <i className="fas fa-envelope text-primary me-3"></i>
                  support@wiziai.com
                </a>
                <div className="mt-3">
                  <p className="text-light opacity-75 mb-2">
                    <i className="fas fa-clock text-primary me-2"></i>
                    Support Hours: 9 AM - 9 PM (Mon-Sun)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-4" style={{
        background: 'linear-gradient(135deg, #1a252f 0%, #2c3e50 100%)'
      }}>
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-light opacity-75">
                <Link to="/" className="text-decoration-none" style={{
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  <i className="fas fa-copyright text-primary me-2"></i>
                  WiZiAi Educational Technologies
                </Link>
                , All rights reserved.
              </span>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="d-flex justify-content-center justify-content-md-end align-items-center">
                <Link to="/cancellation-refund" className="text-light opacity-75 text-decoration-none me-3 hover-primary">
                  Cancellation and Refund
                </Link>
                <Link to="/privacy-policy" className="text-light opacity-75 text-decoration-none me-3 hover-primary">
                  Privacy Policy
                </Link>
                <Link to="/terms" className="text-light opacity-75 text-decoration-none me-3 hover-primary">
                  Terms of Service
                </Link>
                <Link to="/ai-disclaimers" className="text-light opacity-75 text-decoration-none hover-primary">
                  AI Disclaimers
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Link 
        to="/" 
        className="btn btn-lg-square back-to-top position-fixed"
        style={{
          background: 'linear-gradient(135deg, #667eea, #764ba2)',
          border: 'none',
          bottom: '30px',
          right: '30px',
          zIndex: 1000
        }}>
        <i className="fa fa-arrow-up text-white"></i>
      </Link> */}

    </>
  );
};

export default Footer;
